import Unsplash from 'unsplash-js';
import memoizeOne from 'memoize-one';

export const getUnsplashApi = memoizeOne(
  () =>
    new Unsplash({
      applicationId:
        '454087647775b190c574339cb2994716b17ef2f83ad11838d0ef0dac2d102e66',
      secret: '',
    }),
);
